import { useState, useEffect } from 'react';
import { ClienteModel } from '../models/EstudiantesModel';
import { useHistory } from 'react-router-dom';
import { getAllAsignadas } from '../../../service/asignadas/asignadas';

export const useGetAll = (filters: any) => {
  const [data, setData] = useState<ClienteModel[]>([]);
  const [loadingRequest, setLoadingRequest] = useState(0);

  const history = useHistory();
  useEffect(() => {
    const fetchPost = async () => {
      const res = await getAllAsignadas(filters)
        .then()
        .catch((error) => {
          history.push('/error/500');
        });
      if (res) {
        setData(res);
        setLoadingRequest(1);
      }
    };
    fetchPost();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filters]);
  return { data, loadingRequest };
};
